<template>
  <div class="mb-3 mt-3 w-full border-t border-slate-200"></div>
</template>
